var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import React from 'react';
import { observer } from 'mobx-react';
import Pane from '../pane/Pane';
import Section from './Section';
import WSForm from '../ws-form/WSForm';
import styles from './sidebar.module.scss';
import EditorWorkspaces from '../editor-workspaces/EditorWorkspaces';
let Sidebar = class Sidebar extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { store } = this.props;
        return (React.createElement(Pane, { className: styles.root, panel: "sidebar", store: store.layout },
            React.createElement(Section, { store: store.sidebar.server },
                React.createElement(WSForm, { store: store.sidebar.server })),
            React.createElement(Section, { store: store.sidebar.editorWorkspaces },
                React.createElement(EditorWorkspaces, { store: store.sidebar.editorWorkspaces }))));
    }
};
Sidebar = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], Sidebar);
export default Sidebar;
